
<div class="image-container">
  <img src="assets/navimage.png" width="100%" alt="Your Image">
  <div class="image-text">
    <p>Admissions</p>
  </div>
</div> 
<div class="bg-white" style="height: 10vh;"></div>

<mat-tab-group *ngIf="pageData$ | async">
  <mat-tab>
    <ng-template mat-tab-label>
      <mat-icon class="mx-2 align-items-center">description</mat-icon>
      Admission Form
    </ng-template>
    <form [formGroup]="contactForm" (ngSubmit)="submit()" class="container mt-5 pb-4">
      <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 px-4">
            <div class="text-center head_font">
              <span>Fill Enquiry form to get back from Us!</span>
            </div>
            <div class="row mt-3">
              <div class="d-flex flex-column col-lg-6 col-md-6 col-sm-6 px-2" > 
                <label>Name <span class="text-danger">*</span></label>
                <input
                  type="text"
                  class="white-border"
                  placeholder="Enter your name"
                  formControlName="visitorName">

                <small class="text-danger" *ngIf="f.visitorName.touched && f.visitorName.invalid">
                  Name is required (min 3 chars)
                </small>
              </div>
      
              <div class="d-flex flex-column col-lg-6 col-md-6 col-sm-6 px-2"> 
                <label>Email <span class="text-danger">*</span></label>
                <input
                  type="email"
                  class="white-border"
                  placeholder="Enter your email"
                  formControlName="emailId">

                <small class="text-danger" *ngIf="f.emailId.touched && f.emailId.invalid">
                  Enter a valid email
                </small>
              </div>
            </div>

            <div class="row mt-2">
              <div class="d-flex flex-column col-lg-6 col-md-6 col-sm-6 px-2" > 
                <label>Phone <span class="text-danger">*</span></label>
                <input
                  type="text"
                  maxlength="10"
                  class="white-border"
                  placeholder="10 digit phone number"
                  formControlName="phoneNo"
                  (keypress)="allowOnlyNumbers($event)">

                <small class="text-danger" *ngIf="f.phoneNo.touched && f.phoneNo.invalid">
                  Phone must be exactly 10 digits
                </small>
              </div>
      
              <div class="d-flex flex-column col-lg-6 col-md-6 col-sm-6 px-2">
                <label for="class">Class <span class="text-danger">*</span></label>
                <select
                  id="class" name="class" class="white-border" style="border-radius: 5px;"
                  formControlName="admissionClass"
                  placeholder="Select class">

                  <option *ngFor="let cls of classOptions" [value]="cls">
                    {{ cls }}
                  </option>
                </select>

                <small class="text-danger" *ngIf="f.admissionClass.touched && f.admissionClass.invalid">
                  Class is required for admission enquiry
                </small>
              </div>
              
            </div>
      
            <div class="row mt-4">
              <div class="d-flex flex-column col-lg-12 col-md-6 col-sm-6 px-2"> 
                <label>Description <span class="text-danger">*</span></label>
                <textarea
                  rows="4"
                  class="white-border1"
                  placeholder="Write your message..."
                  formControlName="remarks"></textarea>

                <small class="text-danger" *ngIf="f.remarks.touched && f.remarks.invalid">
                  Minimum 10 characters required
                </small>
              </div>
            </div>
            
            <div class="mt-4 text-center">
              <button type="submit"
                [disabled]="contactForm.invalid || loading" 
                mat-button style="background-color: #0A146E; color: #fff;">

                <mat-spinner
                  *ngIf="loading"
                  diameter="22"
                  strokeWidth="3">
                </mat-spinner>

                <span *ngIf="!loading">Send Message</span>
              </button>
            </div>

          </div>
      </div>
    </form>
    
  </mat-tab>

  <mat-tab>
    <ng-template mat-tab-label>
      <mat-icon class="align-items-center">label_important</mat-icon>
      <mat-icon class=" align-items-center">label_important</mat-icon>
      <mat-icon class="align-items-center">label_important</mat-icon>
      <span class="mx-2">Admission Process and Criteria</span> 
    </ng-template>
    <div class="container mt-5 pb-4">
      <div class="row">
          <div class="col-lg-12 col-sm-12 ">
              <div class="brdr_btm">
                  <span class="content3">A. CRITERIA </span>
              </div>
              <div>
                  <table mat-table [dataSource]="dataSource1" class="mt-4 mat-table">

                      <ng-container matColumnDef="slno">
                        <th mat-header-cell *matHeaderCellDef>S. No. </th>
                        <td mat-cell *matCellDef="let element;let i = index" class="brdr" [ngClass]="i % 2 === 0 ? 'even-row' : ''"> {{element.slno}} </td>
                      </ng-container>
                    
                      <ng-container matColumnDef="class">
                        <th mat-header-cell *matHeaderCellDef > CLASS </th>
                        <td mat-cell *matCellDef="let element;let i = index" class="brdr" [ngClass]="i % 2 === 0 ? 'even-row' : ''"> {{element.class}} </td>
                      </ng-container>
                    
                      <ng-container matColumnDef="criteria">
                        <th mat-header-cell *matHeaderCellDef> CRITERIA </th>
                        <td mat-cell *matCellDef="let element;let i = index" class="brdr" [ngClass]="i % 2 === 0 ? 'even-row' : ''"> {{element.criteria}} </td>
                      </ng-container>
                    
                    
                      <tr mat-header-row *matHeaderRowDef="displayedColumns1"></tr>
                      <tr mat-row *matRowDef="let row; columns: displayedColumns1;" ></tr>
                      
                    </table>
              </div>
              <div class="brdr_btm">
                  <span class="content3">B. ADMISSION PROCESS </span>
              </div>

              <div class="content2">Admission procedures in CBSE Schools are on a first-come-first-served basis and seats are limited. Admissions will only be confirmed once the necessary documents and the first-term fee payment is made. Fees once paid will be strictly non-refundable.</div>
                <div class="d-flex mt-2 align-items-center">
                  <span><img src="assets/arrow.svg" alt=""><img src="assets/arrow1.svg" alt=""><img src="assets/arrow1.svg" alt="">
                  <span class="step mx-2">Step 1</span></span>
                </div>


                <div class="accordion" id="accordionPanelsStayOpenExample">
                  <div class="accordion-item">
                    <h2 class="accordion-header"  id="panelsStayOpen-headingOne">
                      <button class="accordion-button" style="background-color:#E9E9E9;box-shadow: none;" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseOne" aria-expanded="true" aria-controls="panelsStayOpen-collapseOne">
                          <img src="assets/bluetick.svg" alt=""> <span class="accord_head">Keep these documents ready</span> 
                      </button>
                    </h2>
                    <div id="panelsStayOpen-collapseOne" class="accordion-collapse collapse show" aria-labelledby="panelsStayOpen-headingOne">
                      <div class="accordion-body">
                          <ul class="content2 mt-2">
                              <li>Birth certificate issued by the authority competent to register birth for class I.</li>
                              <li>Aadhar Card, Passport Size photograph of the student</li>
                              <li>Transfer certificate issued by the school last attended if class II and onwards.</li>
                              <li>Category certificates of the candidates of SC/ST/EWS/ OBC-NCL/ BPL categories issued by the competent authority.</li>
                              <li>Proof of Residence, Photocopy of Address proof and Parent's Pan Card.</li>
                              <li>A service certificate showing no. of transfers during the period of 7 years duly signed and stamped by the head of the office bearing the name, and designation.</li>
                          </ul> 
                      </div>
                    </div>
                  </div>
                </div>

                <div class="d-flex mt-2 align-items-center">
                  <span><img src="assets/arrow.svg" alt=""><img src="assets/arrow1.svg" alt=""><img src="assets/arrow1.svg" alt="">
                  <span class="step mx-2">Step 2</span></span>
                </div>
                <div class="accordion" id="accordionPanelsStayOpenExample">
                  <div class="accordion-item">
                    <h2 class="accordion-header"  id="panelsStayOpen-headingOne">
                      <button class="accordion-button " style="background-color:#E9E9E9;box-shadow: none;" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseOne" aria-expanded="true" aria-controls="panelsStayOpen-collapseOne">
                          <img src="assets/bluetick.svg" alt=""> <span class="accord_head">Fill out the registration form</span> 
                      </button>
                    </h2>
                    <div id="panelsStayOpen-collapseOne" class="accordion-collapse collapse show" aria-labelledby="panelsStayOpen-headingOne">
                      <div class="accordion-body">
                          <ul class="content2 mt-2">
                              <li>The Registration Form consists of all the information on the Selection Criteria and Documents Required for the admission procedure in CBSE Schools. Fill out the registration form carefully and attach all the necessary documents.</li>
                          </ul> 
                      </div>
                    </div>
                  </div>
                </div>
                
                <div class="d-flex mt-2 align-items-center">
                  <span><img src="assets/arrow.svg" alt=""><img src="assets/arrow1.svg" alt=""><img src="assets/arrow1.svg" alt="">
                  <span class="step mx-2">Step 3</span></span>
                </div>
                <div class="accordion" id="accordionPanelsStayOpenExample">
                  <div class="accordion-item">
                    <h2 class="accordion-header"  id="panelsStayOpen-headingThree">
                      <button class="accordion-button" style="background-color:#E9E9E9;box-shadow: none;" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseOne" aria-expanded="true" aria-controls="panelsStayOpen-collapseOne">
                          <img src="assets/bluetick.svg" alt=""> <span class="accord_head">Submit the registration form </span> 
                      </button>
                    </h2>
                    <div id="panelsStayOpen-collapseOne" class="accordion-collapse collapse show" aria-labelledby="panelsStayOpen-headingOne">
                      <div class="accordion-body">
                          <ul class="content2 mt-2">
                              <li>After filling out the school admission form and attaching the required documents, kindly submit the same at your nearest senior secondary school where you wish to enroll your child.</li>
                          </ul> 
                      </div>
                    </div>
                  </div>
                </div>
          </div>
      </div>
    </div>
  </mat-tab>

  <mat-tab>
    <ng-template mat-tab-label>
      <mat-icon class="mx-2 align-items-center">receipt</mat-icon>
      Fee and Rules
    </ng-template>
  <div class="container mt-5 pb-4">
      <div class="row">
          <div class="col-lg-12 col-sm-12 ">
              <div class="brdr_btm">
                  <span class="content3">{{feeRulesContent?.pageTitle || 'A. Fee Rules'}} </span>
              </div>
              <!-- CASE 1: Fee Rules content exists -->
              <ng-container *ngIf="feeRulesContent; else defaultFeeRules">
                <div [innerHTML]="feeRulesContent.content || ''"></div>
              </ng-container>

              <!-- CASE 2: Fallback hardcoded rules -->
              <ng-template #defaultFeeRules>
                <div>
                  <ul class="list mt-2">
                    <li>Registration, Administration, Prospectus and Event/Sports fees are non-refundable.</li>
                    <!-- <li>There will be a minimum increase of 10% in tuition fees annually.</li> -->
                    <li>Tuition fee is payable as per schedule given by school.</li>
                    <li>No reduction/concession in fees is allowed on account of joining late or absence from the school.</li>
                    <li>Fees are charged from the beginning of the Session.</li>
                    <li>Fees are levied for the whole academic year (12 months) and are to be paid.</li>
                    <li>
                      In case of non-compliance in paying the school fees on or before the prescribed date,
                      the name of the student will be removed from the student register at the end of thirty
                      days. Students will only be re-admitted after payment of all dues along with fine and
                      reactivation fee.
                    </li>
                    <li>Students having fee arrears at the time of examination will not be allowed to appear for the examination.</li>
                    <li>In case of withdrawal, parents have to submit one month's prior notice in writing to the school.</li>
                    <li>School leaving certificate or transfer certificate will be issued only after all dues are cleared.</li>
                  </ul>
                </div>
              </ng-template>


              <div class="brdr_btm">
                <span class="content3">{{feeImg?.pageTitle || 'B. Fees'}}</span>
              </div>

              <div class="fee-image-container">

                <!-- CASE 1: Fee Rules content exists -->
                <!-- <ng-container *ngIf="feeImg; else defaultFeeImg">
                  <div class="fee-html-content" [innerHTML]="feeImg.content || ''"></div>
                </ng-container> -->

                <!-- CASE 2: Fallback -->
                <ng-template #defaultFeeImg>
                  <div class="fee-loading">
                    <div class="loader"></div>
                    <p>Loading fee structure...</p>
                  </div>
                </ng-template>

                <!-- CASE 3: Image URL -->
                <img
                  *ngIf="feeImage; else defaultFeeImg"
                  class="fee-image"
                  [src]="feeImage"
                  alt="Fee Image"
                />

              </div>
                
          </div>
      </div>
  </div>
  </mat-tab>
</mat-tab-group>

